import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import Wedding from "@/pages/Wedding";
import Admin from "@/pages/Admin";
import PasswordGate from "@/components/wedding/PasswordGate";
import { SiteContentProvider } from "@/lib/SiteContent";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route
            path="/"
            element={
              <PasswordGate>
                <SiteContentProvider>
                  <Wedding />
                </SiteContentProvider>
              </PasswordGate>
            }
          />
          <Route path="/admin" element={<Admin />} />
        </Routes>
      </BrowserRouter>
      <Toaster
        position="bottom-center"
        toastOptions={{
          style: {
            background: "#3D5E68",
            color: "#F3F5E7",
            border: "none",
            fontFamily: "Outfit, sans-serif",
            fontWeight: 300,
            letterSpacing: "0.02em",
          },
        }}
      />
    </div>
  );
}

export default App;
